<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="provisioningRumList"
            :description="false"
            @selected="handleSelected2"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="heading">
                {{ $t("setup.label.RUM(RatableUsageMetric)") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create RUM' })"
                  size="small"
                  >{{ $t("setup.label.CreateRUM") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.Id") }}</vs-th>
              <vs-th>{{ $t("setup.label.ChargeName") }}</vs-th>
              <vs-th>{{ $t("setup.label.TemplateName") }}</vs-th>
              <vs-th>{{ $t("setup.label.RumName") }}</vs-th>
              <vs-th>{{ $t("setup.label.RumExpression") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="provisioningRumList"
                v-for="(provisioningRumList, index) in data"
              >
                <vs-td :data="provisioningRumList.id">{{
                  provisioningRumList.id
                }}</vs-td>
                <vs-td :data="provisioningRumList.chargeCode">{{
                  provisioningRumList.chargeCode
                }}</vs-td>
                <vs-td :data="provisioningRumList.templateName">{{
                  provisioningRumList.templateName
                }}</vs-td>
                <vs-td :data="provisioningRumList.rumName">{{
                  provisioningRumList.rumName
                }}</vs-td>
                <vs-td :data="provisioningRumList.rumExpression">{{
                  provisioningRumList.rumExpression
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editCreateCommand(provisioningRumList.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                      @click.stop="
                        editJobsRumPopup = true;
                        delId = provisioningRumList.id;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.DeleteRUM')"
              :active.sync="editJobsRumPopup"
              class="popup-close small-popup"
            >
              <div class="center">
                <img src="@/assets/images/pages/delete.svg" />
                <div class="success-msg">
                  {{ $t("system.label.areYouSureDelete") }}
                </div>
              </div>

              <div class="center">
                <span class="p-2">
                  <vs-button type="border" @click="editJobsRumPopup = false">{{
                    $t("system.label.cancel")
                  }}</vs-button></span
                >

                <span class="p-2">
                  <vs-button @click="deleteRumTeam(delId)">{{
                    $t("system.label.confirm")
                  }}</vs-button>
                </span>
              </div>
              <div style="height: 20px"></div>
            </vs-popup>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      editJobsPopup: false,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
      timeList: [],
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      hardwareUomList: (state) => state.usageRating.Uomlist,
      provisioningRumList: (state) => state.usageRating.Rumlist,
      Timemodel: (state) => state.usageRating.GetTimePeriod,
      broadcasters: (state) => state.usageRating.GetTemplate,
      products: (state) => state.usageRating.GetUsageRatePlan,
      timemodel: (state) => state.usageRating.timeModelList,
    }),
  },
  methods: {
    async getCommandData() {
      this.loading = true;
      try {
        this.$store.dispatch("usageRating/setRumList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editCreateCommand(id) {
      this.$router.push({ name: "Edit RUM", params: { id: id } });
    },
    handleSelected2(provisioningRumList) {
      this.$router.push({
        name: "View RUM",
        params: { id: provisioningRumList.id },
      });
    },

    async deleteRumTeam(id) {
      try {
        await this.$store.dispatch("usageRating/deleteRUMAction", id);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "RUM Successfully Deleted",
          type: "success",
        });
        this.getCommandData();
        this.editJobsRumPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  mounted() {
    this.getCommandData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.heading {
  margin-right: auto;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 5px;
}
</style>
